import { quadtree } from 'd3-quadtree';
import { Station } from './station';
import { StationTooltip } from './tooltip';
import './style.css';
import { MapStationLoader } from './loader';
var StationContainer = /** @class */ (function () {
    function StationContainer(auth, map, dashboard) {
        this.auth = auth;
        this.map = map;
        this.dashboard = dashboard;
        this.stations = [];
        this.quadTree = quadtree()
            .x(function (v) { return v.coords.x; })
            .y(function (v) { return v.coords.y; });
        this.tooltip = new StationTooltip();
        this.loader = new MapStationLoader(auth);
    }
    StationContainer.prototype.setOverlay = function (overlay) {
        this.overlay = overlay;
    };
    Object.defineProperty(StationContainer.prototype, "children", {
        // add(station: Station) {
        //     this.quadTree.add(station as any)
        //     this.stations.push(station)
        // }
        get: function () {
            return this.stations;
        },
        enumerable: false,
        configurable: true
    });
    StationContainer.prototype.reload = function () {
        var _this = this;
        return this.loader
            .fetch(this.dashboard.activeSpecie)
            .then(function (map) {
            var stationList = [];
            var toutdated = 0, tstations = 0;
            map.feeds.forEach(function (feed) {
                var noutdated = 0;
                feed.stations.forEach(function (s) {
                    var station = new Station(_this.auth, feed.name, s);
                    if (s.dhours)
                        noutdated++;
                    stationList.push(station);
                });
                var nstations = feed.stations.length;
                _this.dashboard.source(feed.name, nstations, noutdated);
                toutdated += noutdated;
                tstations += nstations;
            });
            stationList.sort(function (a, b) { return (a.zIndex > b.zIndex ? 1 : -1); });
            stationList.forEach(function (station) {
                return _this.quadTree.add(station);
            });
            _this.stations = stationList;
            // if (bounds) this.map.fitBounds(bounds)
            _this.overlay.refresh();
        });
    };
    StationContainer.prototype.resetAQI = function () {
        var available = 0;
        this.stations.forEach(function (station) {
            station.resetAQI();
        });
        this.stations.sort(function (a, b) { return (a.zIndex > b.zIndex ? 1 : -1); });
        this.overlay.refresh();
    };
    StationContainer.prototype.updateAQI = function (feeds) {
        var available = 0;
        this.stations.forEach(function (station) {
            if (feeds[station.source] && feeds[station.source][station.idx]) {
                station.setAQI(feeds[station.source][station.idx]);
                available++;
            }
            else {
                // station.setOutdated(1000)
            }
        });
        this.stations.sort(function (a, b) { return (a.zIndex > b.zIndex ? 1 : -1); });
        this.overlay.refresh();
    };
    StationContainer.prototype.findWorstStation = function () {
        var maxAQI = -1, worstStation;
        var bounds = this.map.getBounds();
        this.stations.forEach(function (station) {
            if (!bounds.contains(station.geo))
                return;
            if (station.AQI < maxAQI)
                return;
            worstStation = station;
            maxAQI = station.AQI;
        });
        return worstStation;
    };
    StationContainer.prototype.findFromPoint = function (point, s) {
        var selected = [];
        var px = point.x, py = point.y;
        if (!this.stations.length)
            return [];
        var r = 16 / s;
        if (r > 16) {
            r -= (r * 32) / 64;
        }
        // this.dashboard.debug(point.toString() + ' -- ' + 1 / s + '>>' + r / 16)
        var ciy0 = py - r, ciy3 = py + r;
        var cix0 = px - r, cix3 = px + r;
        this.quadTree.visit(function (node, x1, y1, x2, y2) {
            var found = false;
            if (!node.length) {
                do {
                    var station = node.data;
                    var _a = station.coords, x = _a.x, y = _a.y;
                    if (x >= cix0 && x < cix3 && y >= ciy0 && y <= ciy3) {
                        var distance = (x - px) * (x - px) + (y - py) * (y - py);
                        selected.push({ distance: distance, station: station });
                        found = true;
                    }
                } while ((node = node.next));
            }
            return x1 >= cix3 || y1 >= ciy3 || x2 < cix0 || y2 < ciy0;
        });
        selected.sort(function (a, b) { return (a.distance > b.distance ? -1 : 1); });
        return selected.slice(0, 5).map(function (x) { return x.station; });
    };
    StationContainer.prototype.findFromLatLng = function (geo) {
        var selected = [];
        var py = geo.lat, px = geo.lng;
        if (!this.stations.length)
            return [];
        var r = 0.2;
        // this.dashboard.debug(point.toString() + ' -- ' + 1 / s + '>>' + r / 16)
        var ciy0 = py - r, ciy3 = py + r;
        var cix0 = px - r, cix3 = px + r;
        this.quadTree.visit(function (node, x1, y1, x2, y2) {
            var found = false;
            if (!node.length) {
                do {
                    var station = node.data;
                    var x = station.geo.lng;
                    var y = station.geo.lat;
                    if (x >= cix0 && x < cix3 && y >= ciy0 && y <= ciy3) {
                        var distance = (px - x) * (px - x) + (py - y) * (py - y);
                        selected.push({ distance: distance, station: station });
                        found = true;
                    }
                } while ((node = node.next));
            }
            return x1 >= cix3 || y1 >= ciy3 || x2 < cix0 || y2 < ciy0;
        });
        selected.sort(function (a, b) { return (a.distance > b.distance ? 1 : -1); });
        return selected.slice(0, 5).map(function (x) { return x.station; });
    };
    StationContainer.prototype.refresh = function () {
        this.dashboard.bounds(this.map.getBounds());
        var sources = {};
        this.stations.forEach(function (station) {
            var source = station.source;
            if (!sources[source])
                sources[source] = [0, 0];
            if (station.isVisible)
                sources[source][0]++;
            if (station.isOutdated)
                sources[source][1]++;
        });
        for (var source in sources) {
            this.dashboard.source(source, sources[source][0], sources[source][1]);
        }
    };
    StationContainer.prototype.showAllSources = function () {
        this.stations.forEach(function (station) {
            station.show();
        });
        this.overlay.refresh();
    };
    StationContainer.prototype.showOnlySource = function (s) {
        var n = 0, t = 0;
        this.stations.forEach(function (station) {
            if (station.source == s) {
                station.highlight();
                n++;
            }
            else
                station.hide();
            t++;
        });
        this.overlay.refresh();
        console.log("there are ", n, "markers out of ", t);
    };
    StationContainer.prototype.highlight = function (selection, latLngToContainerPoint) {
        var _this = this;
        if (selection.length == 0) {
            clearTimeout(this.informationTimer);
            clearTimeout(this.tooltipTimer);
            this.tooltip.hide();
            return;
        }
        if (this.currentHighlight == selection[0])
            return;
        clearTimeout(this.tooltipTimer);
        this.tooltipTimer = setTimeout(function () {
            var point = latLngToContainerPoint(selection[0].geo);
            _this.tooltip.show(point, selection[0], _this.dashboard.activeSpecie);
        }, 10);
        clearTimeout(this.informationTimer);
        this.informationTimer = setTimeout(function () {
            _this.dashboard.highlight(selection);
        }, 1000);
    };
    return StationContainer;
}());
export { StationContainer };
